module.exports = __webpack_public_path__ + "static/media/217-virgin-islands.6f5c0f85.svg";